import React, { useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import CallEndIcon from "@mui/icons-material/CallEnd";
import { connect } from "react-redux";
import {
  joinVoiceRoom,
  leaveVoiceRoom,
} from "../../realtimeCommunication/socketConnection";

const VoiceChannelView = ({ chosenChatDetails }) => {
  const [isJoined, setIsJoined] = useState(false);

  const handleJoin = async () => {
    await joinVoiceRoom(`${chosenChatDetails.serverId}:${chosenChatDetails.id}`);
    setIsJoined(true);
  };

  const handleLeave = () => {
    leaveVoiceRoom();
    setIsJoined(false);
  };

  return (
    <Box
      sx={{
        flexGrow: 1,
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        gap: "18px",
        color: "#f2f3f5",
        p: 3,
        textAlign: "center",
      }}
    >
      <Box
        sx={{
          width: 76,
          height: 76,
          borderRadius: "50%",
          bgcolor: "#f97316",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <VolumeUpIcon sx={{ fontSize: 42 }} />
      </Box>
      <Typography variant="h5" sx={{ fontWeight: 700 }}>
        {chosenChatDetails.name}
      </Typography>
      <Button
        variant="contained"
        startIcon={isJoined ? <CallEndIcon /> : <VolumeUpIcon />}
        onClick={isJoined ? handleLeave : handleJoin}
        sx={{
          bgcolor: isJoined ? "#da373c" : "#f97316",
          textTransform: "none",
          fontWeight: 700,
          minWidth: "190px",
          "&:hover": { bgcolor: isJoined ? "#a12828" : "#ea580c" },
        }}
      >
        {isJoined ? "Выйти" : "Войти"}
      </Button>
    </Box>
  );
};

const mapStoreStateToProps = ({ chat }) => ({
  chosenChatDetails: chat.chosenChatDetails,
});

export default connect(mapStoreStateToProps)(VoiceChannelView);
